import 'core-js'
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux'
import store from './contexts/store'
import '@coreui/coreui/dist/css/coreui.min.css'
import ConnectedAppComponent from './App';
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import './fonts/Montserrat-Medium.ttf';

ReactDOM.render(
  <BrowserRouter>
    <Provider store={store}>
      <ConnectedAppComponent />
    </Provider>
  </BrowserRouter>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals('');
